import { Dispatch } from '@reduxjs/toolkit';
import { setDestinations } from '../actions';
import { AppState } from '../store';

export function getDestinations(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Geography/destinations`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const destinations = await data.json();
      dispatch(setDestinations(destinations));
    } catch (error) {
      console.error(error);
    }
  };
}
